const Masonry = require('masonry-layout');
export function masonry() {
  const masonryContainer = document.querySelectorAll('.js-masonry-container');
  if(masonryContainer) {
    for (let i = 0; i < masonryContainer.length; i++) {
      const _masonryContainer = masonryContainer[i];
      const msn = new Masonry( _masonryContainer, {
        itemSelector: '.js-masonry-item',
        percentPosition: true,
        gutter: '.js-masonry-gutter-sizer',
        transitionDuration: 0
      });
    }
  }
}